import { z } from 'zod';
import { ManualJobResolution } from './resolution.js';
/**
 * How a user closes a manual job. The other two resolutions are orchestrator's to record, not a
 * user's to ask for, and the staff app omits the parameter when it simply drops a job.
 */
export const ManualJobResolveQuerySchema = z
    .object({
    resolution: z
        .enum([ManualJobResolution.Canceled, ManualJobResolution.Completed])
        .default(ManualJobResolution.Canceled),
})
    .strict();
//# sourceMappingURL=resolve.js.map